import { useMemo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { useSurveyConfig } from 'app/core/survey-config';
import { createUseInputRefAndSetAnswer } from 'app/modules/subject';

const useTextLongInputRefAndSetAnswer = createUseInputRefAndSetAnswer<
  string,
  HTMLTextAreaElement
>(
  (inputEl, value) => {
    inputEl.value = value || '';
  },
  inputEl => {
    const { value } = inputEl;
    return value ? [value] : [];
  }
);

export function useTextLongAnswer() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { wording } = useSurveyConfig();
  const attr = useMemo(() => engine.getSubjectData(id).attr || 'text', [
    engine,
    id
  ]);
  const placeholder = wording.message.placeholder.input[attr];

  const { inputRef, onChange, setAnswer } = useTextLongInputRefAndSetAnswer(
    engine,
    id
  );

  return {
    inputRef,
    placeholder,
    onChange,
    onBlur: setAnswer,
    'data-subject-answer': id
  };
}
